<template>
  <div class="d-flex flex-row justify-content-between align-items-start flex-wrap">
    <div class="form-container w-400px">
      <div class="form-label">Sélectionnez une épreuve</div>
      <b-form-select size="sm" class="bg-lightfield" v-model="$store.state.event.current_query_parcours"
        :options="$store.getters['event/getOptionsSelectionEpreuve']" @change="modifyQuery"></b-form-select>
    </div>
    <div class="form-container w-400px" v-if="$store.getters['event/hasPassagesInter']">
      <div class="form-label">Classement points intermédiaires</div>

      <b-form-select size="sm" class="bg-lightfield" v-model="$store.state.event.selection.passage"
        :options="$store.getters['event/getOptionsSelectionPassages']" @change="modifyQueryPassage"></b-form-select>
    </div>
    <div class="form-container" v-if="statistiques">
      <div class="form-label">Statistiques</div>
      <div class="d-flex flex-row justify-content-start align-items-center flex-wrap">
        <div class="chip bg-lightgrey">{{ statistiques.inscrits }} inscrits</div>
        <div class="chip bg-lightgrey">{{ statistiques.depart }} partis</div>
        <div class="chip bg-lightgrey">{{ statistiques.arrives }} arrivés</div>
        <div class="chip bg-lightgrey">{{ statistiques.abandon }} abandons</div>
      </div>
    </div>

  </div>

</template>

<script>
import { query } from 'vue-gtag';


export default {
  components: {

  },
  data() {
    return {
      options: [],
      optionsPassages: []
    }
  },
  computed: {

    statistiques() {
      return this.$store.state.event.data.statistiques_inscriptions;
    }
  },
  methods: {
    async modifyQuery(q) {
      this.$emit("onLoadStart");
      const newQuery = { ...q };
      this.$router.replace({ path: this.$route.path, query: newQuery });
      this.$store.dispatch('event/onChangeQueryParcours', q);
      await this.$store.dispatch('event/fetch');
      this.$emit("onLoadEnd");
    },
    async modifyQueryPassage(i) {
      const newQuery = { ...this.$route.query };
      if (i != "") {
        newQuery.i = i;
      }
      else {
        delete newQuery.i;
      }
      this.$router.push({ name: 'Epreuve', query: newQuery });
      this.$store.dispatch('event/onChangeQueryParcours', newQuery);
      await this.$store.dispatch('event/fetch');
    }
  },


  }
</script>

<style>

</style>
